import { createContext } from 'react';

const ConfirmationDialogContext = createContext(null);
export default ConfirmationDialogContext;
